import { AuthNavDrawer } from "./auth-nav-drawer";
import { AuthNavHeader } from "./auth-nav-header";

/**
 * Props for the AuthNavDrawer component.
 *
 * @property {boolean} open - Whether the drawer is open
 * @property {boolean} isMobile - Whether the drawer is rendered on a mobile device
 * @property {() => void} onDrawerToggle - Handler to toggle the drawer open/closed
 * @property {(width: number) => void} onWidthChange - Handler called when the drawer width changes
 * @property {React.ReactNode} [children] - Optional children to render inside the drawer
 */
export interface AuthNavProps {
    open: boolean;
    isMobile: boolean;
    onDrawerToggle: () => void;
    onWidthChange: (width: number) => void;
    children?: React.ReactNode;
}

/**
 * AuthorizedNavigation
 *
 * Composes the authenticated navigation UI, including the header and drawer.
 * Passes drawer state and handlers to both AuthNavHeader and AuthNavDrawer.
 *
 * @param {AuthorizedNavigationProps} props - The props for the navigation component.
 * @returns {JSX.Element} The rendered navigation UI.
 */
export const AuthorizedNavigation: React.FC<AuthNavProps> = ({
    open,
    isMobile,
    onDrawerToggle,
    onWidthChange,
}) => {
    return (
        <>
            <AuthNavHeader onMenuClick={onDrawerToggle} />
            <AuthNavDrawer
                open={open}
                isMobile={isMobile}
                onDrawerToggle={onDrawerToggle}
                onWidthChange={onWidthChange}
            />
        </>
    );
};
